/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import Admin_Profile from '../../../Components/ExtraComponents/profile/Profile'
import Content from "../../../Components/Dashboard/Content/Content"

const Profile = () => {
  return (
    <div>
        <Admin_Profile/>
        </div>
  )
}

export default Profile

